/**
 * 配置管理 Composable
 * 在 Vue 组件中访问项目配置
 */

import { computed } from 'vue'
import type { AppConfig } from '@/config/loader'
import { getAppConfig, getProjectName } from '@/config/loader'

/**
 * 获取项目配置
 */
export const useConfig = () => {
  const config = getAppConfig()

  return {
    config,
    // 兼容旧版本，保持相同的返回格式
    loading: false,
    error: null,
    reload: () => {
      // 清除缓存重新加载
      const { resetConfigCache } = require('@/config/loader')
      resetConfigCache()
      return getAppConfig()
    }
  }
}

/**
 * 获取当前项目名称
 */
export const useProjectName = () => {
  return computed(() => getProjectName())
}

/**
 * 检查功能是否启用
 */
export const useFeature = (featureName: string): boolean => {
  const config = getAppConfig()

  if (!config?.features) return false

  return config.features[featureName] === true
}

/**
 * 获取服务配置
 */
export const useService = (serviceName: string): string | undefined => {
  const config = getAppConfig()

  return config?.services?.[serviceName]
}

/**
 * 判断当前项目
 */
export const isProject = (projectName: string): boolean => {
  return getProjectName() === projectName
}

/**
 * 获取环境变量
 */
export const useEnv = () => {
  const config = getAppConfig()
  return computed(() => config.env)
}
